import React from 'react';
import { Grid, Button, Typography, Tooltip, Checkbox } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { animated } from '@react-spring/web';
import { FORM_ACTION_BUTTONS } from '../../Constant/FormActions';

const FormItemRow = ({
  item,
  index,
  filteredListData,
  selectDrawerItem,
  checked,
  label,
  handleChangeCheckBox,
  handleChangeStarCheckBoxWrapper,
  copyFormLinkWrapper,
  handleGetFormDetailsWrapper,
  handleGetListResponseFormWrapper,
  moreMenuRef,
  moreMenuTransitions,
  openMoreMenuId,
  setOpenMoreMenuId
}) => {
  return (
    <Grid key={index} width={'100%'} px={'14px'}>
      <Grid
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        sx={{
          p: '24px',
          bgcolor: 'transparent',
          '&:hover': { bgcolor: 'white' },
          borderBottom: index === filteredListData.length - 1 ? 'none' : '1px solid black',
          borderRadius: '0px'
        }}>

        {/* Left section */}
        <Grid sx={{ display: 'flex', alignItems: 'center', gap: '24px', width: '100%' }}>
          <input
            className='check'
            type='checkbox'
            style={{ width: '18px', height: '18px', margin: '0px', display: 'block' }}
            checked={item.checked || false}
            onChange={handleChangeCheckBox(item.id)}
            inputProps={{ 'aria-label': 'controlled' }}
          />
          <Grid width={'36px'} height={'36px'} display={selectDrawerItem === 'AllForm' || selectDrawerItem === 'Favorite' ? 'block' : 'none'}>
            <Checkbox
              style={{ width: '36px', height: '36px' }}
              {...label}
              icon={<StarOutlineIcon fontSize='large' />}
              checkedIcon={<StarIcon style={{ color: '#ffb629' }} fontSize='large' />}
              checked={item.bookmark}
              onChange={handleChangeStarCheckBoxWrapper(item.id)}
            />
          </Grid>
          <Grid width={'32px'} height={'32px'}>
            <img src='/assets/images/checklist.png' alt='' style={{ width: '100%', height: '100%' }} />
          </Grid>
          <Grid pt={'4px'}>
            <Typography variant='h4' color={'rgb(10, 21, 81)'} fontWeight={700}>{item.title}</Typography>
          </Grid>
        </Grid>

        {/* Desktop actions */}
        <Grid display={{ xs: 'none', md: 'flex' }} alignItems={'center'} justifyContent={'flex-end'} gap={'8px'} width={'100%'}>
          {FORM_ACTION_BUTTONS.map(action => (
            action.visibleIn.includes(selectDrawerItem) && (
              <Button
                key={action.id}
                sx={{ alignItems: "center", justifyContent: 'center', width: '24px', height: '48px', '&:hover': { variant: 'contained' } }}
                onClick={() => action.onClick(item.id, { copyFormLinkWrapper, handleGetFormDetailsWrapper, handleGetListResponseFormWrapper })}
              >
                <Grid width={'100%'} height={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                  <Tooltip title={<Typography variant='subtitle1'>{action.tooltip}</Typography>} arrow>
                    {action.icon}
                  </Tooltip>
                </Grid>
              </Button>
            )
          ))}
        </Grid>

        {/* Mobile actions */}
        <Grid sx={{ position: 'relative' }} display={{ xs: 'block', md: 'none' }} width={'40px'} ref={moreMenuRef}>
          <Button onClick={() => setOpenMoreMenuId(item.id)} sx={{ width: '24px', height: '24px' }}>
            <MoreHorizIcon fontSize='large' />
          </Button>
          {moreMenuTransitions((styles, menuId) =>
            menuId === item.id && (
              <animated.div
                style={{
                  ...styles,
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  zIndex: 100,
                  backgroundColor: 'white',
                  borderRadius: '4px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  padding: '8px',
                  minWidth: '180px',
                }}
              >
                <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                  {FORM_ACTION_BUTTONS.map(action => (
                    action.visibleIn.includes(selectDrawerItem) && (
                      <Button
                        key={action.id}
                        onClick={() => {
                          action.onClick(item.id, { copyFormLinkWrapper, handleGetFormDetailsWrapper, handleGetListResponseFormWrapper });
                          setOpenMoreMenuId(null);
                        }}
                        sx={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          justifyContent: 'flex-start',
                          color: 'black',
                          padding: '16px 8px',
                          borderBottom: action.id !== 'responses' ? '1px solid #bfc3ce' : 'none',
                          borderRadius: "0px",
                          '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                        }}
                      >
                        {action.mobileIcon}
                        <Typography variant='body1' fontWeight={700}>{action.label}</Typography>
                      </Button>
                    )
                  ))}
                </Grid>
              </animated.div>
            )
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FormItemRow;